(() => {
  let replayTarget = null;
  let validating = false;
  const maivId = '51235290218802';
  const rushId = '67895789453618';
  function issue(cart) {
    const maiv = cart.items.filter(item => String(item.variant_id) === maivId);
    const rush = cart.items.filter(item => String(item.variant_id) === rushId);
    if (!maiv.length && !rush.length) return '';
    if (maiv.some(item => !item.selling_plan_allocation)) return 'Maiv preorders are not active yet. Please return when preorders launch on November 20 at 9 AM Eastern.';
    const marked = maiv.filter(item => item.properties?.Delivery === 'Rush — December 10, 2026');
    const dollCount = marked.reduce((total, item) => total + item.quantity, 0);
    const rushCount = rush.reduce((total, item) => total + item.quantity, 0);
    if (dollCount !== rushCount) return 'Each rush Maiv doll needs one rush upgrade. Please match their quantities, or remove both and add Maiv again without rush.';
    if (rushCount && cart.items.some(item => String(item.variant_id) !== rushId &&
        (item.selling_plan_allocation || /[(]Ships /i.test(item.product_title || item.title)) &&
        !marked.includes(item))) return 'Please order rush Maiv dolls separately from other preorders so they can arrive by December 10.';
    return '';
  }
  window.addEventListener('click', async event => {
    const target = event.target.closest?.('button[name="checkout"], a[href^="/checkout"], .qsc2-checkout-button');
    if (!target) return;
    if (target === replayTarget) { replayTarget = null; return; }
    const hasMaiv = document.querySelector('a[href*="/products/hmong-cultural-mini-doll"], a[href*="/products/rush-pre-order-option-for-hmong-maiv-doll"]');
    if (!hasMaiv) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (validating) return;
    validating = true;
    let note = document.querySelector('[data-jd-maiv-cart-error]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.jdMaivCartError = '';
      note.setAttribute('role', 'alert');
      note.style.cssText = 'color:#a32038;font-size:13px;line-height:1.5';
      target.before(note);
    }
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {'Accept':'application/json'}});
      if (!response.ok) throw new Error('Unable to verify your rush upgrade. Please try again.');
      const message = issue(await response.json());
      note.textContent = message;
      if (!message) { replayTarget = target; target.click(); }
    } catch (error) {
      note.textContent = error.message || 'Unable to verify your preorder. Please try again.';
    } finally { validating = false; }
  }, true);
})();